import moment from 'moment';
import Vue from 'vue';
import Vuex, { StoreOptions, ActionContext } from 'vuex';
import { get, post, ApiResult } from '../dndg/helpers/api';

// Some types we'll use in actions and mutations
import { User } from '../dndg/access';

// Modules

export interface State {
    isDevelopment: boolean;
    isLoading: boolean;
    isMobile: boolean;
    isAuthenticated: boolean;

    loggedUser: User | null;

    // UI

    lang: string;
    uiMessage: string | null;
    theme: any;
}

export interface Configuration {
    isDevelopment: boolean;
}


// Mutations

function setLang(state: State, lang: string) {
    state.lang = lang;
    moment.locale(lang);
}

function setDevelopment(state: State, isDevelopment: boolean) {
    state.isDevelopment = isDevelopment;
}

function setLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
}

function setMobile(state: State, isMobile: boolean) {
    state.isMobile = isMobile;
}

function setUIMessage(state: State, message: string) {
    state.uiMessage = message;
}

function clearUIMessage(state: State) {
    state.uiMessage = null;
}

function setTheme(state: State, theme: any) {
    state.theme = theme;
}

function clearTheme(state: State) {
    state.theme = null;
}

function resetUI(state: State) {
}

function updateAuthentication(state: State, update: { result: 'OK' | 'ERROR', user: User }) {
    if (update.result == "OK" && !!update.user) {
        state.isAuthenticated = true;
        state.loggedUser = update.user;
    }
    else {
        state.isAuthenticated = false;
        state.loggedUser = null;
    }
}

// Error management

export function checkResult<T>(ctx: ActionContext<State,any>, result: ApiResult<T>) {
    if (result.result == "OK") {
        return result.data || true;
    }
    else {
        //ctx.dispatch('showError', result);
        return false;
    }
}

// Initial state and store options.

const state: State = {
    isDevelopment: true,
    isLoading: false,
    isMobile: false,
    isAuthenticated: false,

    loggedUser: null,

    lang: null,
    uiMessage: null,
    theme: null
}

// Import mutationsm actions and getters from specific application parts.

import * as accessActions from '../dndg/access/actions';
import * as surveyActions from './surveys/actions';
import * as signupActions from './signup/actions';


export default <StoreOptions<State>> {
    state,
    actions: {
        ...accessActions,
        ...surveyActions,
        ...signupActions
    },
    mutations: {
        resetUI,
        setDevelopment,
        setLang,
        setMobile,
        setLoading,
        setUIMessage,
        clearUIMessage,
        setTheme,
        clearTheme,
        updateAuthentication
    }
}



// WEBPACK FOOTER //
// ./src/app/store.ts